<template>
  <div class="listOne" v-show="newList.length > 0">
    <div v-for="(item, index) in newList" :key="index" class="box-list clearfix" @click="shoDetial(item)">
      <div class="box-list-img fl">
        <img :src="item.title_img_path" />
      </div>
      <div class="box-list-font fl">
        <div class="title">{{ item.article_title }}</div>
        <div class="info">{{ item.article_desc }}</div>
      </div>
      <div class="box-list-btn fl">
        <div class="boxDiv" @click="shoDetial(item)">
          <div>
            查看介绍
          </div>
        </div>
      </div>
    </div>
    <div class="page">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    columnId: {
      type: String,
      default: '',

    }
  },
  data() {
    return {
      newList: [],
      total: 0,
      currentPage: 1,
      pageSize: 10
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      let self = this
      this.newList = []
      this.$common.noLoginCallUrl('/api/cp-cms/site/info/getInfoPage', {
        column_id: self.columnId,
        pageNo: self.currentPage,
        pageCount: self.pageSize
      },
        function (res) {
          if (res.code == '000000') {
            self.newList = res.data.data || []
            self.total = res.data.count
          } else {
            self.$message.warning(res.msg)
          }
        })
    },
    handleSizeChange() {

    },
    handleCurrentChange(item) {
      this.currentPage = item
      this.getList()
    },
    shoDetial(item) {
      this.$emit('detail', item)
    }
  },
  watch: { // 监听，当路由发生变化的时候执行

  }
};
</script>

<style lang="less" scoped>
.listOne {
  .box-list {
    // width: 800px;
    margin: 20px auto;
    height: 156px;
    padding: 10px;
    display: flex;
    cursor: pointer;

    .box-list-img {
      width: 125px;
      height: 156px;

      img {
        width: 125px;
        height: 156px;
      }

    }

    .box-list-font {
      height: 156px;
      background-color: #eee;
      padding: 10px;
      box-sizing: border-box;
      width: 1200px;

      .title {
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 10px;
        color: rgb(31, 73, 125);
      }

      .info {
        font-size: 14px;
        line-height: 1.6;
        color: #000000;
        margin-bottom: 10px;
        overflow: hidden;
        display: -webkit-box;
        /* 将对象作为弹性伸缩盒子模型显示 */
        -webkit-line-clamp: 4;
        /* 行数，值可以改，表示展示X行后多余的缩略展示 */
        -webkit-box-orient: vertical;
        /* 设置或检索伸缩盒对象的子元素的排列方式 */
        word-break: break-all;
        border: 1px solid #eef0f5;
      }
    }

    .box-list-btn {
      width: 150px;
      height: 156px;
      background-color: #e4e4e4;
      padding: 10px;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #666;

    }

    .box-list-btn :hover {
      width: 150px;
      height: 156px;
      padding: 10px;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #004fbc;
      color: #fff;
    }
  }

  .page {
    text-align: center;
    margin-bottom: 20px;
  }
}
</style>